import { httpsCallable } from 'firebase/functions';
import { FirebaseError } from 'firebase/app';
import { functions } from '../../constants/firebaseModular';
import * as Sentry from '@sentry/browser';
import type { SetInitialNavObjectPayload, SetInitialNavObjectResponse } from '@usacsmideo/types';

export const setInitialUnifiedNavObject = async (patientId: string) => {
  const setInitialNavObjectFunc = httpsCallable<SetInitialNavObjectPayload, SetInitialNavObjectResponse>(
    functions,
    'setInitialNavObject',
  );

  try {
    const response = await setInitialNavObjectFunc({ uid: patientId });
    return response;
  } catch (error: unknown) {
    if (error instanceof FirebaseError) {
      Sentry.captureException(error);
      console.error('Error calling cloud function', error.code, error.message);
    } else {
      Sentry.captureException(error);
      console.error('Error calling cloud function', error);
    }
    throw error;
  }
};
